import { connect } from 'react-redux';
import {intlShape, injectIntl, FormattedMessage} from 'react-intl';
import Input from '../../../ui/Input';
import React, { Component } from 'react';
import Form from "../../../ui/Form";
import {Field, reduxForm, getFormSubmitErrors} from "redux-form/immutable";
import Button from "../../../ui/Button";

/* eslint-disable react/prop-types, react/no-multi-comp */
const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const { size, ...props } = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage
                        id={`frontend.form_company.label.${props.label || props.input.name}`}
                    />
                </Form.Label>
            )}
            <Input {...props.input} type={props.type}/>
            {props.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.hint} />
                </Form.Hint>
            )}
            {props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};

@injectIntl
export class CreateAddressbook extends Component {
  static propTypes = {
      intl: intlShape.isRequired,
  };

  render() {
      const { submitErrors, handleSubmit } = this.props;

      return (
          <Form onSubmit={handleSubmit}>
              <Field
                  component={renderField}
                  label='name'
                  name='name'
                  required
                  type='text'
                  error={submitErrors && submitErrors.get('name')}
              />

              <br />
              <Button emphasis='primary' type='submit' block>
                  <FormattedMessage id='frontend.form_company.button.save_and_continue' />
              </Button>
          </Form>
      );
  }
}

let FormComponent = reduxForm({
    form: 'company_create',
})(CreateAddressbook);

FormComponent = connect(state => ({
    submitErrors: getFormSubmitErrors('company_create')(state)
}))(FormComponent);

// See https://github.com/erikras/redux-form/issues/1010
export default {
    Component: FormComponent,
};
